import { render, staticRenderFns } from "./new_place.vue?vue&type=template&id=3f8ca7cb&scoped=true&"
import script from "./new_place.vue?vue&type=script&lang=js&"
export * from "./new_place.vue?vue&type=script&lang=js&"
import style0 from "./new_place.vue?vue&type=style&index=0&id=3f8ca7cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8ca7cb",
  null
  
)

export default component.exports